import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import AddressesState from '../../types/Address/AddressesState'

export const addressModule: Module<AddressesState, RootState> = {
  namespaced: true,
  state: {
    selectedAddress: null,
    addresses: [],
    guest_addresses: [],
    addressesLoading: false
  },
  getters,
  actions,
  mutations
}
